/* eslint-disable no-barrel-files/no-barrel-files */
// Barrel files are fine for packages- we just want to avoid them in Forecast proper
export { GeckoColorScale } from './colorscale'
